const getOffsetHours = (date: Date, timezone: string) => {
  const utcDateString = date.toLocaleString('en-US', { timeZone: 'UTC' });
  const utcDate = new Date(utcDateString);
  const tzDateString = date.toLocaleString('en-US', { timeZone: timezone });
  const tzDate = new Date(tzDateString);
  return (tzDate.getTime() - utcDate.getTime()) / (6e4 * 60);
};

export const addOffsetHoursToOtherTimeZone = (date: Date, timezone: string): Date => {
  const offsetHours = getOffsetHours(date, timezone);
  const chileanOffsetHours = getOffsetHours(date, 'America/Santiago');
  const hoursToAdd = offsetHours - chileanOffsetHours;

  if (hoursToAdd < 0) {
    const newDate = new Date(date.getTime() - hoursToAdd * 60 * 60 * 1000);
    return newDate;
  }

  const newDate = new Date(date.getTime() + hoursToAdd * 60 * 60 * 1000);

  return newDate;
};
